// base component
import { PopoverComponent } from './popover.component';

// components

export const PopoverModule = angular.module('topbroker.popovers', [])
  .component('popover', PopoverComponent)
  .name;
